import { useState, useEffect } from "react";

import { Xmark } from "@unified-checkout/design-system/icons/index";
import { Badge, Tooltip } from "@unified-checkout/design-system";

import type {
  IRemovableBadgesGroup,
  TArrBadgeItems
} from "@app/dashboard/types/innerLayout/removableBadgesGroup";
import styles from "./removable-badges-group.module.scss";


export const RemovableBadgesGroup = ({
  list,
  badgesColor = "gray",
  maxVisibleBadges = 10,
  emptyListText,
  badgeTextFormatter,
  remainingItemsBadgeTextFormatter,
  onChange
}: IRemovableBadgesGroup) => {
  const [listing, setListing] = useState(list);

  useEffect(() => {
    setListing(list);
  }, [list]);

  const isArray = Array.isArray(listing);
  const length = isArray ? listing.length : Object.keys(listing).length;
  const mappingList = isArray ? listing : Object.values(listing);

  const visibleItems = mappingList.slice(0, maxVisibleBadges);
  const remainingItems = mappingList.slice(maxVisibleBadges, length);
  const remainingCount = length - maxVisibleBadges;
  const showRemainingItemsBadge = remainingCount > 0;

  const removeItem = (itemId: string | number) => {
    if (isArray) {
      setListing((prev: any) => {
        const filtered = (prev as TArrBadgeItems).filter(item => item.id !== itemId);

        onChange(filtered);
        return filtered;
      });
    } else {
      setListing((prev: any) => {
        const updatedObj = { ...prev };
        Object.keys(updatedObj).find(key => updatedObj[key].id === itemId && delete updatedObj[key]);

        onChange(updatedObj);
        return updatedObj;
      });
    }
  };

  const getBadgeXIcon = (itemId: string | number) =>
    <span
      className={styles["removable-badges-group__badge-x-icon"]}
      onClick={() => removeItem(itemId)}
    >
      {Xmark}
    </span>;

  return (
    !!length ?
      <div className={styles["removable-badges-group"]}>
        {
          visibleItems.map((item: any, i) => {
            return <Badge
              key={`removable-listing-badge-${i}`}
              color={badgesColor}
              text={badgeTextFormatter(item)}
              trailingIcon={getBadgeXIcon(item.id)}
            />
          }
          )
        }
        {
          showRemainingItemsBadge &&
          <Tooltip
            centerArrow
            hintText={remainingItemsBadgeTextFormatter?.(remainingItems) || `+${remainingCount}`}
          >
            <Badge
              color={badgesColor}
              text={`+${remainingCount}`}
            />
          </Tooltip>
        }
      </div>
      :
      emptyListText &&
      <div className={styles["removable-badges-group__empty-list"]}>{emptyListText}</div>
  )
}
